export const USER_DETAILS_ROLE_TITLE = "Roles:userId";

export const linkToUserDetailRolePage = (userId = ":userId") =>
  `/app/settings/users/${userId}/detail?tab=roles`;

export const USER_DETAILS_ROLE_BREADCRUMB = {
  title: USER_DETAILS_ROLE_TITLE,
  path: linkToUserDetailRolePage,
};
